// extracted by mini-css-extract-plugin
export default {"actionsWithDelete":"CustomFieldForm_actionsWithDelete__dQWV5"};